$(".js-cookie_banner_button-all").on("click", function(e){
    e.preventDefault();
    $(".js-cookie_banner_form").find("input").prop("checked", true)
    ajaxCookie();
});

$(".js-cookie_banner_button").on("click", function(e){
    e.preventDefault();
    ajaxCookie();
});

function ajaxCookie(){
    $.ajax({
        url:$(".js-cookie_banner_form").attr("action"),
        type:'POST',
        data: $(".js-cookie_banner_form").serialize() + "&unset=google",
    }).done(function(html){
        $("#cookie-notice").hide(100);
    });
}

$(function (){
    $(".js-cookie_banner_button-all").trigger("focus");
})

$(".js-open_cookie_banner").on("click", function(e){
    e.preventDefault();
    $(".js-cookie_banner").show(100);
})